// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IM7Xq","top":"styles_top__1ueVN","left":"styles_left__385bq","description":"styles_description__1KRib"};